import * as React from "react";
const SvgFiRrSurfing = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-surfing_svg__a)">
      <path
        fill="#062147"
        d="M20 .01c-3.812 0-8.125 2.038-11.539 5.45A38.5 38.5 0 0 0 .323 17.313a3.98 3.98 0 0 0 .851 4.409l1.106 1.105a3.98 3.98 0 0 0 4.4.852 38.3 38.3 0 0 0 11.854-8.14C21.952 12.127 23.99 7.814 23.99 4A3.632 3.632 0 0 0 20 .01m-2.875 14.115A36.4 36.4 0 0 1 5.9 21.84a2 2 0 0 1-2.026-.3L16.707 8.707a1 1 0 1 0-1.414-1.414L2.457 20.129a2.01 2.01 0 0 1-.3-2.028A36.4 36.4 0 0 1 9.875 6.875C13.463 3.288 17.458 2.01 20 2.01c1.451 0 1.99.539 1.99 1.99 0 2.543-1.278 6.538-4.865 10.125"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-surfing_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSurfing;
